import { render, staticRenderFns } from "./TreatmentVarietyCard.vue?vue&type=template&id=9c6110b6&"
import script from "./TreatmentVarietyCard.vue?vue&type=script&lang=js&"
export * from "./TreatmentVarietyCard.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentVarietyCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports